import React from 'react';
import PriceItemList from '../PriceItemList/PriceItemList';
import PriceItemListCellular from '../PriceItemList/PriceItemListCellular';
import CheckBox from '../../../../Shared/CheckBox/Checkbox';
import {buildUrlAndOpenWindow} from '../../../../../utilities/StringHelpers/StringHelpers';

const Summary = (props) => {
  return (
    <div className='summary-wrapper'>
      {props.summaryDetails.saleType == 'cellular' ? (
        <PriceItemListCellular summaryDetails={props.summaryDetails} />
      ) : (
        <PriceItemList summaryDetails={props.summaryDetails} />
      )}

      {(props.summaryDetails.supplyType == 'technician' || props.summaryDetails.supplyType == 'delivery') && (
        <>
          <div className='show-address-location'>
            <div className='title-order-detail'>פרטי הזמנה</div>
            <div className='sub-order-detail'>
              {props.summaryDetails.supplyType == 'technician' && (
                <div className='row-details'> מועד הגעת הטכנאי: {props.summaryDetails.selectedTechnicianTimeDisplay} </div>
              )}
              {props.summaryDetails.supplyType == 'delivery' && (
                <div className='row-details'>מתי השליח יגיע: {props.summaryDetails.selectedDeliveryTimeDisplay} </div>
              )}
              {props.summaryDetails.saleType != 'app' && (
                <div className='row-details'>
                  כתובת: {props.summaryDetails.selectedAddress?.streetName} {props.summaryDetails.selectedAddress?.home} ,
                  {props.summaryDetails.selectedAddress?.cityName}
                </div>
              )}
              {props.summaryDetails.saleType != 'app' && (
                <div className='row-details'>
                  טלפון ליצירת קשר: {props.summaryDetails.personalInfo?.firstName} {props.summaryDetails.personalInfo?.subscriberNo}
                </div>
              )}
            </div>

            <div className='remark'>
              {' '}
              <span> חשוב שיהיה בבית בגיר מעל גיל 18 כדי לקבל את המשלוח</span>{' '}
            </div>
          </div>
        </>
      )}

      <div className='checkbox-wrapper'>
        <CheckBox
          id='terms-checkbox'
          onChange={() => {
            console.debug('[terms-checkbox] changed');
            props.onClickConfirmTerms();
          }}
          checked={props.isConfirmTerms}
          label={
            <>
              {' '}
              קראתי ואני מסכים{' '}
              <a href='#' onClick={() => buildUrlAndOpenWindow(props.programDetailsLink)}>
                לעיקרי פרטי התכנית
              </a>
              ,{' '}
              <a href='#' onClick={() => buildUrlAndOpenWindow(props.connectionAgreementLink)}>
                להסכם ההתקשרות
              </a>{' '}
              <a href='#' onClick={() => buildUrlAndOpenWindow(props.generalTermsAgreementLink)}>
                ולתנאים הכלליים
              </a>{' '}
            </>
          }
        />
        {props.confirmTermsErrorText && <div className='error'>{props.confirmTermsErrorText}</div>}
      </div>
    </div>
  );
};
export default Summary;
